import React from 'react';
import Navbar from '../../components/layout/Navbar';
import SiteFooter from '../../components/layout/Footer';

const team = [
  { name: 'MS Discoveries', role: 'Product Team', avatar: '🏢' },
  { name: 'Support Team', role: 'Mon–Sat · 10AM–6PM', avatar: '🎧' },
  { name: 'Engineering', role: 'Platform & Infrastructure', avatar: '⚙️' },
  { name: 'Deliverability', role: 'Email Experts', avatar: '📬' },
];

const stats = [
  { value: '500+', label: 'Businesses Served' },
  { value: '10M+', label: 'Emails Warmed Up' },
  { value: '94%', label: 'Avg Inbox Rate' },
  { value: '3', label: 'Years of Excellence' },
];

export default function About() {
  return (
    <div style={{ background: '#0A0A0A', minHeight: '100vh', color: '#fff' }}>
      <Navbar />

      {/* Hero */}
      <section style={{ paddingTop: 140, paddingBottom: 80, textAlign: 'center', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', top: '40%', left: '50%', transform: 'translate(-50%,-50%)', width: 600, height: 600, background: 'radial-gradient(circle, rgba(46,204,113,0.06) 0%, transparent 70%)', pointerEvents: 'none' }} />
        <div style={{ display: 'inline-block', background: 'rgba(46,204,113,0.08)', border: '1px solid rgba(46,204,113,0.25)', borderRadius: 20, padding: '5px 16px', fontSize: 11, fontWeight: 800, color: '#2ECC71', letterSpacing: 2, textTransform: 'uppercase', marginBottom: 20 }}>About Us</div>
        <h1 style={{ fontSize: 60, fontWeight: 900, marginBottom: 20, letterSpacing: -2 }}>
          We Help Businesses<br /><span style={{ color: '#2ECC71' }}>Reach the Inbox</span>
        </h1>
        <p style={{ fontSize: 18, color: '#666', maxWidth: 640, margin: '0 auto', lineHeight: 1.9 }}>
          MS Discoveries is a digital solutions company built around one mission — making sure your emails land where they're meant to: the inbox, not the spam folder.
        </p>
      </section>

      {/* Stats Bar */}
      <section style={{ padding: '0 80px 80px', maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 2, background: 'rgba(46,204,113,0.08)', borderRadius: 20, border: '1px solid rgba(46,204,113,0.15)', overflow: 'hidden' }}>
          {stats.map((s, i) => (
            <div key={s.label} style={{ textAlign: 'center', padding: '32px 20px', borderRight: i < 3 ? '1px solid rgba(46,204,113,0.1)' : 'none' }}>
              <div style={{ fontSize: 40, fontWeight: 900, color: '#2ECC71', marginBottom: 6 }}>{s.value}</div>
              <div style={{ fontSize: 13, color: '#666' }}>{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Story */}
      <section style={{ padding: '0 80px 80px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 60, maxWidth: 1200, margin: '0 auto', alignItems: 'center' }}>
        <div>
          <div style={{ display: 'inline-block', background: 'rgba(46,204,113,0.08)', border: '1px solid rgba(46,204,113,0.2)', borderRadius: 20, padding: '5px 14px', fontSize: 11, fontWeight: 800, color: '#2ECC71', letterSpacing: 2, textTransform: 'uppercase', marginBottom: 20 }}>Our Story</div>
          <h2 style={{ fontSize: 40, fontWeight: 900, marginBottom: 20, lineHeight: 1.2 }}>Built Because <span style={{ color: '#2ECC71' }}>We Felt the Pain</span></h2>
          <p style={{ fontSize: 15, color: '#777', lineHeight: 2, marginBottom: 20 }}>
            MS Discoveries was founded after seeing countless businesses struggle with email deliverability. Campaigns would go unread, not because the content was bad — but because they were landing in spam. The root cause? No proper email warmup.
          </p>
          <p style={{ fontSize: 15, color: '#777', lineHeight: 2 }}>
            We built EmailMark to be the complete solution: warmup, campaign management, email verification, CRM, A/B testing, and deep analytics — all under one roof, built for businesses of every size.
          </p>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          {[
            { icon: '🎯', title: 'Mission', text: 'Help businesses reach their customers\' inbox through reliable, proven email deliverability solutions.' },
            { icon: '🌍', title: 'Vision', text: 'Become a trusted global platform for email marketing infrastructure and deliverability.' },
            { icon: '💡', title: 'Innovation', text: 'Continuously improve our warmup algorithms, verification accuracy, and campaign intelligence.' },
            { icon: '🤝', title: 'Commitment', text: 'Every client gets dedicated support and tools that actually move the needle on deliverability.' },
          ].map(c => (
            <div key={c.title} style={{ background: '#111', border: '1px solid rgba(46,204,113,0.1)', borderRadius: 16, padding: 24, transition: 'all 0.2s' }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(46,204,113,0.3)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(46,204,113,0.1)'; e.currentTarget.style.transform = 'none'; }}>
              <div style={{ fontSize: 28, marginBottom: 10 }}>{c.icon}</div>
              <div style={{ fontSize: 14, fontWeight: 800, color: '#2ECC71', marginBottom: 8 }}>{c.title}</div>
              <p style={{ fontSize: 12, color: '#666', lineHeight: 1.7 }}>{c.text}</p>
            </div>
          ))}
        </div>
      </section>

      {/* What We Offer */}
      <section style={{ padding: '60px 80px 80px', background: 'rgba(46,204,113,0.02)', borderTop: '1px solid rgba(46,204,113,0.06)' }}>
        <div style={{ textAlign: 'center', marginBottom: 56, maxWidth: 1200, margin: '0 auto 56px' }}>
          <h2 style={{ fontSize: 44, fontWeight: 900 }}>What We <span style={{ color: '#2ECC71' }}>Offer</span></h2>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 20, maxWidth: 1200, margin: '0 auto' }}>
          {[
            { icon: '🌡️', title: 'Email Warmup System', items: ['Multi-account support', 'Automated daily sending', 'Reputation score tracking', 'Real email interactions'] },
            { icon: '📧', title: 'Campaign Platform', items: ['Cold email campaigns', 'Follow-up sequences', 'Personalization tags', 'Smart sending windows'] },
            { icon: '✅', title: 'Email Verification', items: ['Format validation', 'MX/DNS record check', 'SMTP mailbox ping', 'Bulk CSV upload'] },
            { icon: '🧪', title: 'A/B Testing', items: ['Subject or body split', 'Custom traffic splits', 'Auto-winner by open rate', 'Manual override option'] },
            { icon: '🏆', title: 'CRM Pipeline', items: ['7-stage Kanban view', 'Auto-stage movement', 'Activity timeline', 'Pipeline value tracking'] },
            { icon: '📊', title: 'Analytics & Reporting', items: ['Real-time open/click tracking', 'Bounce & reply rates', 'Warmup score charts', 'Revenue reporting'] },
          ].map(item => (
            <div key={item.title} style={{ background: '#111', border: '1px solid rgba(46,204,113,0.1)', borderRadius: 18, padding: '28px 24px' }}>
              <div style={{ fontSize: 28, marginBottom: 12 }}>{item.icon}</div>
              <h3 style={{ fontSize: 15, fontWeight: 800, color: '#fff', marginBottom: 16 }}>{item.title}</h3>
              <ul style={{ listStyle: 'none' }}>
                {item.items.map(i => <li key={i} style={{ fontSize: 13, color: '#666', padding: '5px 0', borderBottom: '1px solid rgba(255,255,255,0.03)', display: 'flex', gap: 8 }}><span style={{ color: '#2ECC71', flexShrink: 0 }}>✓</span>{i}</li>)}
              </ul>
            </div>
          ))}
        </div>
      </section>

      {/* Disclaimer */}
      <section style={{ padding: '40px 80px 60px', maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ background: 'rgba(243,156,18,0.04)', border: '1px solid rgba(243,156,18,0.18)', borderRadius: 16, padding: '24px 28px' }}>
          <h4 style={{ color: '#F39C12', marginBottom: 10, fontSize: 15 }}>⚠️ Important Disclaimer</h4>
          <p style={{ fontSize: 13, color: '#666', lineHeight: 1.9 }}>Email deliverability depends on several factors including sender reputation, email content, recipient engagement, and external email provider policies. While our system helps improve email warmup and sender reputation, <strong style={{ color: '#888' }}>MS Discoveries does not guarantee inbox placement for all emails</strong>. Results vary based on usage patterns and external factors beyond our control.</p>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
}
